import {
  createEffect,
  createEvent, createStore, restore, sample
} from 'effector';
import { createGate } from 'effector-react';
import { once } from 'patronum';
import { api } from 'src/shared/api/api';
import { addNewSecondStageUnits } from '../lib/helpers/addNewSecondStageUnits/addNewSecondStageUnits';
import { addNewVote } from '../lib/helpers/addNewVote/addNewVote';
import { getCurrentNominationLabel } from '../lib/helpers/getCurrentNominationLabel/getCurrentNominationLabel';
import { getCurrentNominationNominees } from '../lib/helpers/getCurrentNominationNominees/getCurrentNominationNominees';
import {
  INominationsResponce,
  INominee,
  NominationsT,
  PostVoteT,
  SecondStageVotesT
} from './types';

export const PretendentsGate = createGate();

const getPollItemsFx = createEffect<void, INominationsResponce[], Error>(api.getSecondStagePretendents);
const pretendentsGateOpen = once(PretendentsGate.open);

export const setCurrentNomination = createEvent<NominationsT>();
export const $currentNominationName = createStore<NominationsT | null>(null);
export const $currentNominationLabel = createStore<string>('');
export const $pollItems = createStore<INominationsResponce[]>([]);
export const $currentNomitionPretendents = createStore<INominee[] | null>(null);

export const setPretendents = createEvent<PostVoteT>();
const $newPretendents = restore(setPretendents, {});
export const $firstStageVotes = createStore<PostVoteT>({});

export const setSecondStageVote = createEvent<SecondStageVotesT | null>();
export const setSecondStageLabel = createEvent<SecondStageVotesT | null>();
const $newSecondStageVote = restore(setSecondStageVote, null);
const $newSecondStageLabel = restore(setSecondStageLabel, null);
export const resetSecondStageVotes = createEvent();
export const $secondStageVotes = createStore<SecondStageVotesT | null>(null);
export const $secondStageLabels = createStore<SecondStageVotesT | null>(null);

sample({
  clock: $newPretendents,
  source: { $newPretendents, $firstStageVotes },
  fn: addNewVote,
  target: $firstStageVotes
});

sample({
  clock: pretendentsGateOpen,
  target: getPollItemsFx
});

sample({
  clock: getPollItemsFx.doneData,
  target: $pollItems
});

sample({
  clock: setCurrentNomination,
  target: $currentNominationName
});

sample({
  clock: $currentNominationName,
  source: { $currentNominationName, $pollItems },
  fn: getCurrentNominationLabel,
  target: $currentNominationLabel
});

sample({
  clock: $currentNominationLabel,
  source: { $currentNominationName, $pollItems },
  fn: getCurrentNominationNominees,
  target: $currentNomitionPretendents
});

sample({
  clock: $newSecondStageVote,
  source: {
    newSecondStageUnit: $newSecondStageVote,
    secondStageUnit: $secondStageVotes
  },
  fn: addNewSecondStageUnits,
  target: $secondStageVotes
});

sample({
  clock: $newSecondStageLabel,
  source: {
    newSecondStageUnit: $newSecondStageLabel,
    secondStageUnit: $secondStageLabels
  },
  fn: addNewSecondStageUnits,
  target: $secondStageLabels
});

sample({
  clock: resetSecondStageVotes,
  fn: () => null,
  target: [$secondStageVotes, $secondStageLabels]
});
